require('./contractAresLoanRequestError.scss');

// @vendor
const React = require('react');
const { withRouter } = require("react-router-dom");
const PropTypes = require('prop-types');
// @components
const WizardError = require('components/commons/wizardError/wizardError');
// @core
const { formatText, FormattedText } = require('core/i18n').i18n;
// @constants
const translations = require('./contractAresLoanRequestError.translations');
// @utilities
const { recordLinkV2, recordPathV2, PAGE_CONTRACT_ARES_LOAN_ERROR } = require('utilities/tagging');
const { catalogue, analyticsId } = require( '../analytics/contractAresLoanAnalytics' );

class ContractAresLoanRequestError extends React.Component {
    constructor(props) {
        super(props);

        this.handleBackToGlobalPosition = this.handleBackToGlobalPosition.bind(this);
    }

    componentDidMount() {
        recordPathV2(catalogue[analyticsId.ERROR_VIEW](this.props.error.description));
    }

    handleBackToGlobalPosition() {
        recordLinkV2({
            categoriaEvento: PAGE_CONTRACT_ARES_LOAN_ERROR,
            accionEvento: "volver a posicion global"
        });
        this.props.history.push('/myprofile/global');
    }

    render() {
        return (
            <section className="col-xs-12 contract-ares-loan-request-error">
                <WizardError
                    errorMessage={formatText(translations.TITLE)}
                    mainButton={{ label: formatText(translations.BACK_BUTTON).toUpperCase() }}
                    onMainButtonClick={this.handleBackToGlobalPosition}
                >
                    <div className="contract-ares-loan-request-error__content">
                        <FormattedText
                            value={translations.DESCRIPTION}
                            className="payroll-loan-request-error__message"
                        />
                        <FormattedText value={translations.DESCRIPTION_2} />
                    </div>
                </WizardError>
            </section>
        );
    }
}

ContractAresLoanRequestError.propTypes = {
    error: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

module.exports = withRouter(ContractAresLoanRequestError);
